const initialState = {
  userData: null
}

const UserData = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER_DATA":
      return { ...state, userData: action.val }
    default:
      return state
  }
}
export default UserData
